import { render, staticRenderFns } from "./SliderImages.vue?vue&type=template&id=468ceb2e&scoped=true"
import script from "./SliderImages.vue?vue&type=script&lang=js"
export * from "./SliderImages.vue?vue&type=script&lang=js"
import style0 from "./SliderImages.vue?vue&type=style&index=0&id=468ceb2e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468ceb2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte\\Onlytonapoli\\onlytonapoliapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('468ceb2e')) {
      api.createRecord('468ceb2e', component.options)
    } else {
      api.reload('468ceb2e', component.options)
    }
    module.hot.accept("./SliderImages.vue?vue&type=template&id=468ceb2e&scoped=true", function () {
      api.rerender('468ceb2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SliderImages.vue"
export default component.exports